import React, { Fragment, useState } from 'react';
import './terminal.css';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

function Terminal() {
    const [nome,setNome] = useState('');
    const [mesa,setMesa] = useState('');
    const [email,setEmail] = useState('');
    const [phone,setPhone] = useState('');

    const location = useLocation();
    const data = location.state.nome;

    function handleInputChangeName(event){
        setNome(event.target.value);
        handleInputChangesetMesa();
    }
    function handleInputChangesetMesa(){
        setMesa(data)
    }
    function handleInputChangesetEmail(event){
        setEmail(event.target.value);
    }
    function handleInputChangesetPhone(event){
        setPhone(event.target.value);
    }

    function createPost() {
        axios
          .post('http://localhost:3030/mesas', {
            nome,
            email,
            phone,
            mesa
          })
      }
    return (
        <Fragment>
            <div className="container-term">
                <form onSubmit={createPost}>
                    <p>Confirme reserva</p>
                    <p>Mesa Escolhida {data}</p>
                    <input 
                        className="input-form" 
                        type="text" 
                        placeholder="Seu Nome" 
                        onChange={handleInputChangeName}/><br />
                    <input 
                        className="input-form" 
                        type="email" 
                        placeholder="Seu Email" 
                        onChange={handleInputChangesetEmail}/><br />
                    <input 
                        className="input-form" 
                        type="tel" 
                        placeholder="(xx)xxxx-xxxx" 
                        required 
                        onChange={handleInputChangesetPhone}/><br />
                    <input 
                        className="input-form" 
                        type="submit" 
                        value="Sign in" /><br />
                </form>
            </div>
        </Fragment>
    )
}

export default Terminal;